var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React from 'react';
import classnames from 'classnames';
import { Button, Edit, ArrowUpward, ChevronLeft, ChevronRight } from '../icon/';
import Select from '../select/';
import keycode from 'keycode';

// internal helper component

var EditDialog = function (_React$Component) {
  _inherits(EditDialog, _React$Component);

  function EditDialog() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, EditDialog);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = EditDialog.__proto__ || Object.getPrototypeOf(EditDialog)).call.apply(_ref, [this].concat(args))), _this), _this.onSubmit = function (event) {
      event.preventDefault();
      _this.props.onClose();
    }, _this.onKeyUp = function (event) {
      if (event.which === keycode('escape')) {
        _this.props.onClose();
      }
    }, _this.onClick = function (event) {
      // make sure click happened outside of component
      var element = _this.c;
      // https://github.com/tj/react-click-outside/blob/master/index.js#L25
      if (!element.contains(event.target)) {
        _this.props.onClose();
      }
    }, _this.componentDidMount = function () {
      document.addEventListener('click', _this.onClick);
      document.addEventListener('keyup', _this.onKeyUp);
    }, _this.componentWillUnmount = function () {
      document.removeEventListener('click', _this.onClick);
      document.removeEventListener('keyup', _this.onKeyUp);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(EditDialog, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      return React.createElement(
        'div',
        { className: 'mdc-Table-edit', ref: function ref(c) {
            _this2.c = c;
          } },
        React.createElement(
          'form',
          { onSubmit: this.onSubmit, className: 'mdc-Table-edit-container' },
          this.props.children
        )
      );
    }
  }]);

  return EditDialog;
}(React.Component);

var Table = function Table(_ref2) {
  var children = _ref2.children,
      className = _ref2.className,
      dense = _ref2.dense,
      rest = _objectWithoutProperties(_ref2, ['children', 'className', 'dense']);

  return React.createElement(
    'table',
    _extends({
      className: classnames('mdc-Table', className, {
        'mdc-Table--dense': dense
      })
    }, rest),
    children
  );
};

export { Table };
var TableResponsive = function TableResponsive(_ref3) {
  var children = _ref3.children,
      className = _ref3.className,
      rest = _objectWithoutProperties(_ref3, ['children', 'className']);

  return React.createElement(
    'div',
    _extends({ className: 'mdc-Table-responsive' }, rest),
    children
  );
};

export { TableResponsive };
var TableHead = function TableHead(_ref4) {
  var children = _ref4.children,
      className = _ref4.className,
      rest = _objectWithoutProperties(_ref4, ['children', 'className']);

  return React.createElement(
    'thead',
    { className: classnames('mdc-Table-head') },
    children
  );
};

export { TableHead };
var TableHeadRow = function TableHeadRow(_ref5) {
  var children = _ref5.children,
      className = _ref5.className,
      rest = _objectWithoutProperties(_ref5, ['children', 'className']);

  return React.createElement(
    'tr',
    _extends({ className: classnames('mdc-Table-head-row', className) }, rest),
    children
  );
};

// Arrow component is not exported and used internally for sorted columns.
export { TableHeadRow };
var Arrow = function Arrow(_ref6) {
  var sorted = _ref6.sorted;
  return React.createElement(ArrowUpward, {
    width: 16,
    height: 16,
    className: classnames('mdc-Table-head-row-cell-button-arrow', {
      'mdc-Table-head-row-cell-button-arrow--descending': sorted === 'desc',
      'mdc-Table-head-row-cell-button-arrow--ascending': sorted === 'asc'
    })
  });
};

var TableHeadCell = function TableHeadCell(_ref7) {
  var children = _ref7.children,
      className = _ref7.className,
      sorted = _ref7.sorted,
      onClick = _ref7.onClick,
      rest = _objectWithoutProperties(_ref7, ['children', 'className', 'sorted', 'onClick']);

  return React.createElement(
    'th',
    _extends({ className: classnames('mdc-Table-head-row-cell', className) }, rest),
    sorted ? React.createElement(
      'button',
      { className: 'mdc-Table-head-row-cell-button', onClick: onClick },
      React.createElement(Arrow, { sorted: sorted }),
      children
    ) : children
  );
};

export { TableHeadCell };
var TableBody = function TableBody(_ref8) {
  var children = _ref8.children,
      className = _ref8.className,
      rest = _objectWithoutProperties(_ref8, ['children', 'className']);

  return React.createElement(
    'tbody',
    _extends({ className: classnames('mdc-Table-body', className) }, rest),
    children
  );
};

export { TableBody };
var TableBodyRow = function TableBodyRow(_ref9) {
  var children = _ref9.children,
      className = _ref9.className,
      selected = _ref9.selected,
      rest = _objectWithoutProperties(_ref9, ['children', 'className', 'selected']);

  return React.createElement(
    'tr',
    _extends({
      className: classnames('mdc-Table-body-row', className, {
        'is-selected': selected
      })
    }, rest),
    children
  );
};

export { TableBodyRow };
export var TableBodyCell = function (_React$Component2) {
  _inherits(TableBodyCell, _React$Component2);

  function TableBodyCell() {
    var _ref10;

    var _temp2, _this3, _ret2;

    _classCallCheck(this, TableBodyCell);

    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    return _ret2 = (_temp2 = (_this3 = _possibleConstructorReturn(this, (_ref10 = TableBodyCell.__proto__ || Object.getPrototypeOf(TableBodyCell)).call.apply(_ref10, [this].concat(args))), _this3), _this3.state = {
      isEditing: false
    }, _this3.show = function () {
      _this3.setState({
        isEditing: true
      });
    }, _this3.hide = function () {
      _this3.setState({
        isEditing: false
      });
    }, _temp2), _possibleConstructorReturn(_this3, _ret2);
  }

  _createClass(TableBodyCell, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          className = _props.className,
          textfield = _props.textfield,
          rest = _objectWithoutProperties(_props, ['children', 'className', 'textfield']);

      return React.createElement(
        'td',
        _extends({ className: classnames('mdc-Table-body-row-cell', className) }, rest),
        this.state.isEditing ? React.createElement(
          EditDialog,
          { onClose: this.hide },
          textfield
        ) : null,
        textfield ? React.createElement(
          'div',
          { className: 'mdc-Table-body-row-cell-edit-wrapper', onClick: this.show },
          children,
          React.createElement(Edit, {
            className: 'mdc-Table-edit-icon',
            width: 18,
            height: 18,
            fill: 'rgba(0, 0, 0, 0.54)'
          })
        ) : children
      );
    }
  }]);

  return TableBodyCell;
}(React.Component);

export var TableFooter = function TableFooter(props) {
  return React.createElement(
    'div',
    { className: 'mdc-Table-footer' },
    React.createElement(
      'span',
      { className: 'mdc-Table-footer-rowsPerPage' },
      props.labelRowsPerPage
    ),
    React.createElement(Select, {
      options: props.possibleRowsPerPage,
      onChange: props.onChangeRowsPerPage,
      value: props.rowsPerPageIndex
    }),
    React.createElement(
      'span',
      { className: 'mdc-Table-footer-xOfY' },
      props.labelXOfY
    ),
    React.createElement(
      Button,
      { onClick: props.onPaginateLeft },
      React.createElement(ChevronLeft, { fill: 'rgba(0, 0, 0, 0.54)' })
    ),
    React.createElement(
      Button,
      { onClick: props.onPaginateRight },
      React.createElement(ChevronRight, { fill: 'rgba(0, 0, 0, 0.54)' })
    )
  );
};


//////////////////
// WEBPACK FOOTER
// ../es/js/table/index.js
// module id = 311
// module chunks = 0